import CryptoJS from 'crypto-js';

export const parseJwtPayload = (token: string) => {
  const parts = token.split('.');
  if (parts.length !== 3) throw new Error('Invalid JWT format');
  const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
  const padded = b64 + '==='.slice((b64.length + 3) % 4);
  const words = CryptoJS.enc.Base64.parse(padded);
  const json = CryptoJS.enc.Utf8.stringify(words);
  return JSON.parse(json);
};

export const convertTimestampToDate = (timestamp: number) => {
  const date = new Date(timestamp * 1000);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}:${day}:${year}`;
};

export const convertPrice = (
  price: string | number,
  exChangeRate: number = 1
) => {
  return (
    Math.floor(Number(price) * exChangeRate * 100) / 100
  ).toLocaleString();
};

export const resizeImageFromUrl = (url: string, maxSize = 200) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous'; // cần nếu ảnh từ domain khác
    img.onload = () => {
      const canvas = document.createElement('canvas');
      let { width, height } = img;

      if (width > height) {
        if (width > maxSize) {
          height *= maxSize / width;
          width = maxSize;
        }
      } else {
        if (height > maxSize) {
          width *= maxSize / height;
          height = maxSize;
        }
      }

      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx?.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL('image/jpeg', 0.7));
    };
    img.src = url;
  });
};

export const getDisplayedOriginal = (price: any, originalPrice: any) => {
  if (!originalPrice) return '';
  const orig = Number(originalPrice);
  return orig === Number(price) ? orig * 1.3 : orig;
};
